import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const PaySvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#1F2647",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M12.001 21.9995C17.4744 21.9995 22.0097 17.4729 22.0097 11.9995C22.0097 6.5261 17.4657 1.99951 11.9923 1.99951C6.52365 1.99951 2.00098 6.5261 2.00098 11.9995C2.00098 17.4729 6.53236 21.9995 12.001 21.9995ZM12.0058 17.7559C11.7489 17.7559 11.5608 17.5718 11.5608 17.311V16.557C10.1874 16.4377 9.06506 15.6742 8.78076 14.4993C8.76815 14.4061 8.74679 14.3042 8.74679 14.2063C8.74679 13.8814 8.96976 13.6585 9.27893 13.6585C9.55628 13.6585 9.74527 13.803 9.845 14.1239C9.99826 14.8551 10.5936 15.4005 11.5608 15.5237V12.4075L11.4712 12.3784C9.79727 11.9861 8.94008 11.226 8.94008 9.96914C8.94008 8.61213 10.0462 7.66355 11.5608 7.5055V6.80243C11.5608 6.53771 11.745 6.36223 12.0058 6.36223C12.2579 6.36223 12.4499 6.54161 12.4499 6.80243V7.5055C13.7668 7.64222 14.7941 8.40359 15.0571 9.48411C15.0784 9.58207 15.0998 9.68394 15.0998 9.78583C15.0998 10.1067 14.8768 10.3297 14.5598 10.3297C14.2642 10.3297 14.0839 10.1542 13.9976 9.86422C13.8017 9.14906 13.2425 8.67943 12.4499 8.56885V11.5061L12.6253 11.5383C14.367 11.8648 15.2465 12.6772 15.2465 14.0185C15.2465 15.5131 14.0388 16.4377 12.4499 16.5697V17.311C12.4499 17.5679 12.2579 17.7559 12.0058 17.7559ZM11.5608 11.2706V8.56885C10.6598 8.69686 10.077 9.2479 10.077 9.91686C10.077 10.5663 10.5236 10.9724 11.4928 11.2579L11.5608 11.2706ZM12.4499 12.6257V15.5237C13.5442 15.4171 14.1134 14.8377 14.1134 14.0795C14.1134 13.3922 13.7261 12.9569 12.6645 12.6849L12.4499 12.6257Z"
        fill={color}
      />
    </svg>
  );
};

export { PaySvg };
